import "../CSS/footer.css";


const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-section">
                    <h3>Address:</h3>
                    <p>Shantipura, behind Little Flower High School,</p>
                    <p>Chavni, Chatrapati Shambaji Nagar (Aurangabad)- 431002</p>
                    <p>Tel. +91-91755-999-26</p>
                </div>
                <div className="footer-section">
                    <h3>Corporate Office:</h3>
                    <p>2A, Plot No.6, Kesharsingpura, Padampura Rd,</p>
                    <p>Aurangabad, Maharashtra 431001</p>
                    <p>Email. info@infinitytechresources.com</p>
                </div>
            </div>
            <div className="copyright">
                <p>© 2024 by Souvik Roy Choudhury. All rights are reserved</p>
            </div>
        </footer>
    );
};

export default Footer;
